import { render, staticRenderFns } from "./ReportField.vue?vue&type=template&id=12216a04"
import script from "./ReportField.vue?vue&type=script&lang=js"
export * from "./ReportField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports